import { render, staticRenderFns } from "./Grilla.vue?vue&type=template&id=50319ada&"
import script from "./Grilla.vue?vue&type=script&lang=js&"
export * from "./Grilla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports